import React, { useState } from 'react';
import './confirm.scss';
import cx from 'classnames';
const ConfirmButton = (props) => {
  const {
    type = 'button',
    buttonText,
    buttonClassName,
    confirmMessage,
    confirmTitle,
    confirm,
  } = props;
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <>
      {type === 'button' && (
        <button
          className={cx('button', buttonClassName)}
          onClick={(e) => {
            e.preventDefault();
            setShowConfirm(true);
          }}
        >
          {buttonText}
        </button>
      )}

      {type === 'link' && (
        <a
          href="#"
          className={cx('link', buttonClassName)}
          onClick={(e) => {
            e.preventDefault();
            setShowConfirm(true);
          }}
        >
          {buttonText}
        </a>
      )}

      {showConfirm && (
        <div className="confirm">
          <div className="confirm__message">
            <a className="close" onClick={() => setShowConfirm(false)}>
              x
            </a>
            <div className="message">
              <strong>{confirmTitle}</strong>
              <p>{confirmMessage}</p>
            </div>
            <div className="button-group">
              <button
                className="button cancel secondary"
                type="button"
                onClick={() => setShowConfirm(false)}
              >
                No
              </button>
              <button
                className="button primary"
                type="button"
                onClick={confirm}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmButton;
